// Epic 8 design pass — the certificate display serial.
//
// The design's certificate face shows a registry serial in the GH-XXXX-XXXX
// form (design/claude-design/templates/market-page/PatronageCertificate.dc.html).
// The user's review question — "Serial (uuid?)" — resolves to: derive the
// human-facing serial deterministically from the share's own uuid, so it is
// stable, unique, and needs no extra wire field.
//
// Derivation: take the first 8 hex nibbles of the uuid (strip dashes),
// uppercase, and group 4-4 behind a "GH-" prefix. Example:
//   "9c41d2f7-1e2b-4a..." → "GH-9C41-D2F7".
//
// Shared by every certificate mapper (marketplace card + buy modal, vault
// grid, share detail) so the serial reads identically wherever a cert renders.

/** Derive the GH-XXXX-XXXX display serial from a share uuid. */
export function certSerialFromShareId(shareId: string): string {
  const hex = shareId.replace(/-/g, "").slice(0, 8).toUpperCase();
  // Defensive pad — a well-formed uuid always yields 8 hex chars, but never
  // emit a malformed group if handed a short/empty id.
  const padded = hex.padEnd(8, "0");
  return `GH-${padded.slice(0, 4)}-${padded.slice(4, 8)}`;
}
